var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 0H2.10938C0.943922 0 0 0.749131 0 1.66375V11.6463C0 12.5663 0.950859 13.31 2.10938 13.31H21.8906C23.0463 13.31 24 12.5694 24 11.6463V1.66375C24 0.750758 23.0598 0 21.8906 0ZM21.5952 1.10917C21.1642 1.44728 13.7476 7.26626 13.4916 7.46717C13.0931 7.78143 12.5634 7.95446 12 7.95446C11.4366 7.95446 10.9069 7.7814 10.5071 7.46613C10.3349 7.331 3.00014 1.57627 2.40478 1.10917H21.5952ZM1.40625 11.4205V1.89021L7.48303 6.65796L1.40625 11.4205ZM2.40567 12.2008L8.48006 7.44018L9.51408 8.25146C10.1781 8.77521 11.061 9.06363 12 9.06363C12.939 9.06363 13.8219 8.77521 14.4846 8.2525L15.5199 7.44018L21.5943 12.2008H2.40567ZM22.5938 11.4205L16.517 6.65796L22.5938 1.89021V11.4205Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.15c877bdcb35cdc5fa77fb5c8d6e4e39.svg";
export { ForwardRef as ReactComponent };